
import {Component, Vue} from 'vue-property-decorator'
import {backToBefore} from "@/utils/h5ToApp";

@Component({
})
export default class privacyPolicy extends Vue {
    handleBack() {
      if(this.$route.query.formPage === 'h5') {
        this.$router.back()
      } else {
        backToBefore()
      }
    }
}
